import { call, put, select, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllBannerResponse,
  getBannerByIdResponse,
  getBannersByDefaultResponse,
  getVideoBannerResponse,
  getImageBannersResponse,
  getActiveBannersResponse,
} from "../actions";

export function* createBannerEffectSaga(action) {
  try {
    const companyId = yield select((s) => s?.login?.user?.companyId);
    const { data } = yield call(() =>
      axiosPost(`banner`, { companyId, ...action.data?.payload })
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Banner added successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateBannerEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`banner/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Banner edited successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllBannerEffectSaga(action) {
  try {
    const companyId = yield select((s) => s?.login?.user?.companyId);
    const { data } = yield call(() => axiosGet(`banner/company/${companyId}`));
    yield put(getAllBannerResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllBannerResponse([]));
  }
}

export function* getBannerByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`banner/1`));
    yield put(getBannerByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getBannerByIdResponse([]));
  }
}

export function* deleteBannerEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`banner/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Banner deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getBannersByDefaultEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`banner/default`));
    yield put(getBannersByDefaultResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getBannersByDefaultResponse([]));
  }
}

export function* getVideoBannerEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`banner/video`));
    yield put(getVideoBannerResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getVideoBannerResponse([]));
  }
}

export function* getImageBannersEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`banner/image`));
    yield put(getImageBannersResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getImageBannersResponse([]));
  }
}

export function* getActiveBannersEffectSaga(action) {
  try {
    const companyId = yield select((s) => s?.login?.user?.companyId);
    const { data } = yield call(() => axiosGet(`banner/active/company/${companyId}`));
    yield put(getAllBannerResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllBannerResponse([]));
  }
}
export function* getInActiveBannersEffectSaga(action) {
  try {
    const companyId = yield select((s) => s?.login?.user?.companyId);
    const { data } = yield call(() => axiosGet(`banner/inActive/company/${companyId}`));
    yield put(getAllBannerResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllBannerResponse([]));
  }
}

export function* bannerWatcherSaga() {
  yield takeLatest(types.CREATE_BANNER, createBannerEffectSaga);
  yield takeLatest(types.UPDATE_BANNER, updateBannerEffectSaga);
  yield takeLatest(types.GET_ALL_BANNER, getAllBannerEffectSaga);
  // yield takeLatest(types.GET_BANNER, getBannerByIdEffectSaga);
  yield takeLatest(types.DELETE_BANNER, deleteBannerEffectSaga);
  // yield takeLatest(types.GET_BANNER, getBannersByDefaultEffectSaga);
  // yield takeLatest(types.GET_BANNER, getVideoBannerEffectSaga);
  // yield takeLatest(types.GET_BANNER, getImageBannersEffectSaga);
  yield takeLatest(types.GET_BANNER, getActiveBannersEffectSaga);
  yield takeLatest(types.GET_INACTIVE_BANNER, getInActiveBannersEffectSaga);
}
